export default __webpack_public_path__ + "static/media/streak_arrow.125c7937.svg";